var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading
    ? _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("b-spinner", {
            attrs: { label: "Loading...", variant: "primary" },
          }),
        ],
        1
      )
    : _vm.existingActions.length > 0
    ? _c(
        "div",
        [
          _c(
            "b-list-group",
            { staticClass: "mb-0" },
            _vm._l(_vm.existingActions, function (existingAction, i) {
              return _c(
                "b-list-group-item",
                {
                  key: "existing-" + i,
                  staticClass:
                    "d-flex justify-content-between align-items-center",
                },
                [
                  _c(
                    "div",
                    [
                      existingAction.dateCompleteConfirmed
                        ? _c("font-awesome-icon", {
                            staticClass: "text-success mr-2",
                            attrs: {
                              icon: _vm.confirmIcon,
                              title: _vm.formatDate(
                                "Date Confirmed",
                                existingAction.dateCompleteConfirmed
                              ),
                            },
                          })
                        : existingAction.dateComplete
                        ? _c("font-awesome-icon", {
                            staticClass: "text-warning mr-2",
                            attrs: {
                              icon: _vm.completeIcon,
                              title: _vm.formatDate(
                                "Date Complete",
                                existingAction.dateComplete
                              ),
                            },
                          })
                        : _c("font-awesome-icon", {
                            staticClass: "text-danger mr-2",
                            attrs: {
                              icon: _vm.outstandingIcom,
                              title: "Outstanding",
                            },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-grow-1" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("formatDate")(existingAction.dateRaised)
                        ) +
                        " -\n        " +
                        _vm._s(existingAction.description) +
                        "\n        "
                    ),
                    existingAction.imageCount > 0
                      ? _c("span", [
                          _vm._v(
                            "(" + _vm._s(existingAction.imageCount) + " Images "
                          ),
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  _vm.selectedActionId = existingAction.id
                                },
                              },
                            },
                            [_vm._v("view")]
                          ),
                          _vm._v(")"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    existingAction.completeUser
                      ? _c("span", [
                          _vm._v(
                            " - complete by " +
                              _vm._s(existingAction.completeUser)
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  !existingAction.dateCompleteConfirmed
                    ? _c(
                        "b-button",
                        {
                          staticClass: "my-1",
                          attrs: {
                            size: "sm",
                            disabled: existingAction.isSaving,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.complete(existingAction)
                            },
                          },
                        },
                        [
                          existingAction.isSaving
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v("\n        Confirm\n      "),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("recommendation-images", {
            attrs: {
              show: _vm.selectedActionId != null,
              "customer-id": _vm.customerId,
              "site-id": _vm.siteId,
              "action-id": _vm.selectedActionId,
            },
            on: {
              hide: function ($event) {
                _vm.selectedActionId = null
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }